import * as React from 'react';
import { Box, Grid, Button, TextField, Input, LinearProgress } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FormHelperText from '@mui/material/FormHelperText';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { pnkstore } from '../../stores/pnk-store';
import { DateTimePicker } from '@mui/x-date-pickers';


export const UserDetailsComp = (props) => {


    return (
        <Box>
            <Box className="form-head">
                <Grid container>
                    <Grid md={3}>
                        <Box>
                            <Button className='grey-theme-btn' variant="outlined" startIcon={<ArrowBackIcon />} onClick={() => props.NavigateTo('users')}>
                                Back
                            </Button>
                        </Box>
                    </Grid>
                </Grid>

            </Box>

            <Box style={{ marginTop: '20px' }}>
                <Grid container>
                    <Grid md={3}>
                        <Box p={2}>
                            <TextField className="text-input" id="txtUserName" name='txtUserName' error={props.UserFormData.txtUserNameErr == undefined || props.UserFormData.txtUserNameErr == '' ? false : true} helperText={props.UserFormData.txtUserNameErr} onChange={(e) => props.HandleInputs(e, 'txtUserName')} value={props.UserFormData.txtUserName || ''} label="User Name*" variant="outlined" />
                        </Box>
                    </Grid>
                    <Grid md={3}>
                        <Box p={2}>
                            <TextField className="text-input" id="txtUserMobile" name='txtUserMobile' error={props.UserFormData.txtUserMobileErr == undefined || props.UserFormData.txtUserMobileErr == '' ? false : true} helperText={props.UserFormData.txtUserMobileErr} onChange={(e) => props.HandleInputs(e, 'txtUserMobile')} value={props.UserFormData.txtUserMobile || ''} label="User Mobile*" inputProps={{ maxLength: 10 }} variant="outlined" />
                        </Box>
                    </Grid>
                    <Grid md={3}>
                        <Box p={2}>
                            <TextField className="text-input" id="txtUserAltMobile" name='txtUserAltMobile' error={props.UserFormData.txtUserAltMobileErr == undefined || props.UserFormData.txtUserAltMobileErr == '' ? false : true} helperText={props.UserFormData.txtUserAltMobileErr} onChange={(e) => props.HandleInputs(e, 'txtUserAltMobile')} value={props.UserFormData.txtUserAltMobile || ''} inputProps={{ maxLength: 10 }} label="User Alternate Mobile" variant="outlined" />
                        </Box>
                    </Grid>
                    <Grid md={3}>
                        <Box p={2}>
                            <TextField className="text-input" id="txtUserEmail" name='txtUserEmail' disabled={props.mystate.mode === 'edit' ? true : false} error={props.UserFormData.txtUserEmailErr == undefined || props.UserFormData.txtUserEmailErr == '' ? false : true} helperText={props.UserFormData.txtUserEmailErr} onChange={(e) => props.HandleInputs(e, 'txtUserEmail')} value={props.UserFormData.txtUserEmail || ''} label="User Email*" variant="outlined" />
                        </Box>
                    </Grid>
                    <Grid md={3}>
                        <Box p={2}>
                            <TextField className="text-input" id="txtUserAltEmail" name='txtUserAltEmail' error={props.UserFormData.txtUserAltEmailErr == undefined || props.UserFormData.txtUserAltEmailErr == '' ? false : true} helperText={props.UserFormData.txtUserAltEmailErr} onChange={(e) => props.HandleInputs(e, 'txtUserAltEmail')} value={props.UserFormData.txtUserAltEmail || ''} label="User Alternate Email" variant="outlined" />
                        </Box>
                    </Grid>
                    <Grid md={3}>
                        <Box p={2}>
                            <FormControl fullWidth>
                                <TextField
                                    select
                                    value={props.UserFormData.ddlUserType || ''}
                                    label="User Profile*"
                                    error={props.UserFormData.ddlUserTypeErr == undefined || props.UserFormData.ddlUserTypeErr == '' ? false : true}
                                    onChange={(e) => props.HandleInputs(e, 'ddlUserType')}
                                >
                                    {
                                        props.mystate.profileList.length > 0 ?
                                            props.mystate.profileList.map((item) =>
                                                <MenuItem value={item.profile_name}>{item.profile_name}</MenuItem>
                                            )
                                            :
                                            null
                                    }
                                </TextField>
                                <FormHelperText style={{ color: 'red' }}>{props.UserFormData.ddlUserTypeErr}</FormHelperText>
                            </FormControl>
                        </Box>
                    </Grid>


                    <Grid md={3}>
                        <Box p={2}>
                            <FormControl fullWidth>
                                <TextField
                                    select
                                    value={props.UserFormData.ddlReportingName || ''}
                                    label="Reporting Name*"
                                    error={props.UserFormData.ddlReportingNameErr == undefined || props.UserFormData.ddlReportingNameErr == '' ? false : true}
                                    onChange={(e) => props.HandleInputs(e, 'ddlReportingName')}
                                >
                                    <MenuItem value={'admin'}>{'admin'}</MenuItem>
                                    {
                                        props.mystate.userList.length > 0 ?
                                            props.mystate.userList.map((item) =>
                                                <MenuItem value={item.user_name}>{item.user_name + ' (' + item.user_profile_name + ')'}</MenuItem>
                                            )
                                            :
                                            null
                                    }
                                </TextField>
                                <FormHelperText style={{ color: 'red' }}>{props.UserFormData.ddlReportingNameErr}</FormHelperText>
                            </FormControl>
                        </Box>
                    </Grid>

                    {
                        props.mystate.mode === 'edit' ?

                            <Grid md={3}>
                                <Box p={2}>
                                    <FormControl fullWidth>
                                        <TextField
                                            select
                                            value={props.UserFormData.ddlUserStatus === 0 ? 0 : props.UserFormData.ddlUserStatus}
                                            label="User Status*"
                                            error={props.UserFormData.ddlUserStatusErr == undefined || props.UserFormData.ddlUserStatusErr == '' ? false : true}
                                            onChange={(e) => props.HandleInputs(e, 'ddlUserStatus')}
                                        >
                                            <MenuItem value={0}>{'In-Active'}</MenuItem>
                                            <MenuItem value={1}>{'Active'}</MenuItem>

                                        </TextField>
                                        <FormHelperText style={{ color: 'red' }}>{props.UserFormData.ddlUserStatusErr}</FormHelperText>
                                    </FormControl>
                                </Box>
                            </Grid>
                            :
                            null
                    }


                    {
                        props.mystate.mode === 'edit' && props.UserFormData.ddlUserStatus === 0 ?
                            <Grid xs={12} md={3}>
                                <Box p={2}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DatePicker']}>
                                            <DatePicker maxDate={dayjs(new Date())} sx={{ width: '100%' }} onChange={(e) => props.HandleInputs(e, 'txtDol')} label="DOL" value={dayjs(props.UserFormData.txtDol != undefined ? props.UserFormData.txtDol : '')}

                                            />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </Box>
                            </Grid>
                            :
                            null
                    }



                </Grid>

                <Grid container>
                    <Grid md={12}>
                        <Box m={2} textAlign={'center'}>
                            {
                                props.mystate.mode == 'add' ?

                                    props.mystate.addUser == true ?

                                        <LoadingButton
                                            loading
                                            loadingPosition="start"
                                            startIcon={<SaveIcon />}
                                            variant="outlined"
                                        >
                                            Add New User
                                        </LoadingButton>
                                        :

                                        <Button className='grey-theme-btn' variant="outlined" onClick={() => props.AddUser()}>Add New User</Button>
                                    :
                                    props.mystate.editUser == true ?

                                        <LoadingButton
                                            loading
                                            loadingPosition="start"
                                            startIcon={<SaveIcon />}
                                            variant="outlined"
                                        >
                                            Update User
                                        </LoadingButton>
                                        :
                                        props.mystate.txtUserName == '' ?
                                            ''
                                            :
                                            <Button className='grey-theme-btn' variant="outlined" onClick={() => props.AddUser()}>Update User</Button>
                            }

                        </Box>
                    </Grid>
                </Grid>

            </Box>
        </Box>


    );
}